import { connect } from 'react-redux'
import HostPage from '../components/HostPage'


const mapStateToProps = (state, { socket }) => ({
    socket: socket,
    numPlayers: state.numPlayers,
})

const mapDispatchToProps = (dispatch, { socket }) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HostPage)



// WEBPACK FOOTER //
// ./src/containers/HostPage.js